










































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import {IEditor, Editor,CustomDirectEditProvider} from '@/agiles/common/validator';
// import { SettlementTypes } from '../../models/All';
// import { ReturnDeliveryQuery } from '../../models/All';

@Component
export default class AloneInvoiceView extends Vue {
  public cancelBookSales = Components.CancelBookSales;
  public items: Common.AloneInvoice[] = new Array(0);
  public params: Common.InvoiceQuery = new Common.InvoiceQuery(false);
  public exportQuery = new Common.InvoiceExportQuery('請求',this.params,false,Common.SalesPurchaseFlags.Sales);
  public importQuery = new Common.InvoiceImportQuery('請求',Common.SalesPurchaseFlags.Sales);
  public sortOptions: any = [
    { value: 'State', text: '状態' },
    { value: 'invoiceNo', text: '請求書番号' },
    { value: 'closingDate', text: '請求締日' },
    { value: 'counterpart', text: '得意先' },
    { value: 'exchangeRate', text: '計上レート' },
    { value: 'dueDate', text: '入金予定日' },
    { value: 'provisionalClosingDate', text: '仮締日' },
    { value: 'refNo', text: '請求管理番号' },
    { value: 'segment', text: '部門' },
  ];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;  
  public invoiceTypes = Common.InvoiceTypes;
  public invoiceStatus = Common.InvoiceStatus;
  @Prop() public invoiceNo:string;
  
  public tabVisibles: boolean[] = null;
  public calcUtil: Common.CalcUtil = new Common.CalcUtil();
  // 一覧可変表示用プロパティ
  public hasLicenseCurrency: boolean = false;  
  public hasLicenseExport: boolean = false;  
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');

  // 支払情報タブ可変表示用プロパティ
  public paymentTabCaptions = new Array();
  public paymentTabWidths = new Array();
  public paymentTabSlots = new Array();
  public paymentTabGridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');

  // ワークフロー処理用プロパティ
  public buttonNames: Array<string> = null;
  public buttonIndexIdArray: Array<{index:number,actionId:number}> =null;

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;    
    // 検索条件を設定する
    if(this.invoiceNo) {
      this.params.invoiceNo = this.invoiceNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
        
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    this.hasLicenseExport = this.$api.hasLicense(Common.licenseFlags.export);    
    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('請求書番号', 150),
      new Common.GridItemConfiguration('ワークフロー', 170),
      new Common.GridItemConfiguration('請求締日', 100),
      new Common.GridItemConfiguration('得意先', 180),
      new Common.GridItemConfiguration('請求通貨', 100,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('請求金額', 120),      
      new Common.GridItemConfiguration('計上レート', 120,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('入金予定日', 100),
      new Common.GridItemConfiguration('請求締', 100),      
      new Common.GridItemConfiguration('請求方法', 150),      
      new Common.GridItemConfiguration('繰越対象', 100),
      new Common.GridItemConfiguration('繰越処理', 150),      
      new Common.GridItemConfiguration('決済条件', 150),      
      new Common.GridItemConfiguration('決済方法', 150),     
      new Common.GridItemConfiguration('請求口座', 150), 
      //new Common.GridItemConfiguration('現金口座', 150),      
      new Common.GridItemConfiguration('手数料額', 150),            
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('請求管理番号', 150),
      // new Common.GridItemConfiguration('税計算区分', 150),
      new Common.GridItemConfiguration('入金額', 150),
      new Common.GridItemConfiguration('請求残高', 150),      
      new Common.GridItemConfiguration('税抜金額', 150),
      new Common.GridItemConfiguration('消費税額', 150),
      new Common.GridItemConfiguration('計上金額', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('計上税額', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('税込計上額', 150,this.hasLicenseCurrency),            
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;

    this.paymentTabGridConfig.setGridItems(
      new Common.GridItemConfiguration('入金伝票番号', 150),
      new Common.GridItemConfiguration('消込', 120),
      new Common.GridItemConfiguration('入金日', 120),
      new Common.GridItemConfiguration('入金通貨', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('入金レート', 150,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('入金額', 150),
      new Common.GridItemConfiguration('入金計上額', 150,this.hasLicenseCurrency),      
    );
    this.paymentTabCaptions = this.paymentTabGridConfig.gridCaptions;
    this.paymentTabWidths = this.paymentTabGridConfig.gridWidths;
    this.paymentTabSlots = this.paymentTabGridConfig.gridSlots;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    
    if (this.hasLicenseExport) this.tabVisibles = [true,true,true,true,true,true,true];
    else this.tabVisibles = [true,true,true,true,true,true,true]; //スタンダードでも前受金タブを表示
    this.$api.formatter.ensureListLoaded('workflow_receivePayment');
  }

  public async onCreate(obj: Common.Invoice) {
    const workflows = this.$api.formatter.getOptions('workflow_aloneInvoice');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //請求明細タブのリロード
    (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();   
  }
  
  public async preSendAction(item :Common.Invoice, action:Common.WorkflowAction)
  {
    // freee連携をする場合は確定処理前に状態をチェックする
    if(this.tenantSettings.dealApiType == Common.dealApiTypes.freee && action.stateIdFrom < Common.InvoiceStatus.AloneReceiptWaiting && action.stateIdTo >= Common.InvoiceStatus.AloneReceiptWaiting)
    {
      // 繰越が前回実施済みの場合連携しない旨のメッセージを表示する（処理は継続する）
      if(item.rolloverFlag == Common.RolloverFlags.previous) await this.$api.modal.showDialog('','繰越処理が前回実施済みのため、freeeへの取引伝票連携は行いません。',false);
    }
  }

  public get workflowRequired() {
    return this.$api.formatter.getOptions('workflow_aloneInvoice').length != 0;
  }

  public isEditable(settlement: Common.SettlementTypes): boolean{
    return settlement == Common.SettlementTypes.ByCash;
  }

  public isEditableState(state: Common.InvoiceStatus):boolean{
    return state == Common.InvoiceStatus.AloneClosingWaiting;
  }

  // 決済方法が売掛に変更された場合、入金予定日を設定する
  public onChangeSettlement(item: Common.Invoice){
    if(item.settlement == Common.SettlementTypes.ByReceivable) item.dueDate = item.counterpart.getPaymentDate(new Date(item.closingDate), this.tenantSettings);
  }

  public async onDelete(){
    var selectedItems =  (this.$refs.mainList as Components.ListView).selectedItems;
    return this.$api.modal.showDialog('確認メッセージ', selectedItems.length + '件のデータを本当に削除してよろしいですか?', false)
        .then(() => {
          this.$api.startWaitCusor();
          return this.$api.execute(new Common.InvoiceDeleteQuery(selectedItems)).finally(()=>this.$api.closeWaitCursor());
        }); //更新処理エラーは握り潰してリスト更新を実行させる必要がある。
  }


  // 一覧でチェックされている請求
  public checkedInvoices: Array<Common.Invoice>= new Array(0);
  public getCheckedInvoices(){
    this.checkedInvoices = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.writeoffAmountFC = 0;
        this.checkedInvoices.push(obj);
      }
    });
  }

  // 入金処理用プロパティ
  public brSegment: Common.Segment = null;
  public brPic: string = '';
  public brWorkflowId:number = 0;
  public brCounterpart: Common.Counterpart = null;
  public brCurrencyCode: string = '';
  public brReceiptDate: Date = new Date;
  public brBankAccount: Common.BankAccount = null;
  public brDescription: string = '';
  public brExchangeRate:number = 0;
  public get brReceiptAmountFC(): number { return this.brSettlementAmountFC - this.brCommissionAmountFC; };
  public brCommissionAmountFC: number = 0;
  public brCommissionTaxFlag: boolean = false;
  public get brSettlementAmountFC(): number {
    if(this.checkedInvoices.length == 0) return 0;
    return this.checkedInvoices.map(obj => obj.writeoffAmountFC).reduce((total, value) =>(total + value));
  };
  public brMin(invoice:Common.Invoice): number{
    if(invoice.pendingBalanceAmountFC > 0) return 0;
    else return invoice.pendingBalanceAmountFC;
  }
  public brMax(invoice:Common.Invoice): number{
    if(invoice.pendingBalanceAmountFC < 0) return 0;
    else return invoice.pendingBalanceAmountFC;
  }
  public brDecimal: number = 0;

  //エディタからの入金処理
  public showBilledReceiptDialog2(){
    this.checkedInvoices = new Array(0);
    this.checkedInvoices.push(this.selectedInvoice);
    this.showBilledReceiptDialogExec();    
  }
  
  // 入金ダイアログの表示
  public showBilledReceiptDialog() {
    this.getCheckedInvoices();

    // ダイアログ表示前バリデーション
    if(this.checkedInvoices.length == 0){
      this.$api.modal.show('', '対象の伝票を選択して下さい。', true, null);            
      return;
    }
    if(this.checkedInvoices.filter(invoice=> (invoice.counterpart.id != this.checkedInvoices[0].counterpart.id)).length > 0){
      this.$api.modal.show('', '得意先の異なる請求データを、同じ入金伝票にまとめることはできません。', true, null);
      return;
    }
    if(this.checkedInvoices.filter(invoice=> (invoice.currencyCode != this.checkedInvoices[0].currencyCode)).length > 0){
      this.$api.modal.show('', '請求通貨の異なる請求データを、同じ入金伝票にまとめることはできません。', true, null);
      return;
    }
    if(this.checkedInvoices.filter(invoice=> (invoice.segmentId != this.checkedInvoices[0].segmentId)).length > 0){
      this.$api.modal.show('', '部門の異なる請求データを、同じ入金伝票にまとめることはできません。', true, null);
      return;
    }    
    if(this.checkedInvoices.filter(invoice=> (invoice.state & (Common.InvoiceStatus.AloneReceiptWaiting | Common.InvoiceStatus.AlonePartReceipt)) == Common.InvoiceStatus.Alone).length > 0){
      this.$api.modal.show('', '入金処理待ち・入金処理中の伝票を選択してください。', true, null);
      return;
    }       
    if(this.checkedInvoices.filter(invoice=> (invoice.billedBalanceAmountFC == 0)).length > 0){
      this.$api.modal.show('', '請求残高のある請求データを選択して下さい。', true, null);
      return;
    }
    if(this.checkedInvoices.filter(invoice=> (invoice.state & Common.InvoiceStatus.AloneCompleted) > Common.InvoiceStatus.Purchase).length > 0){
      this.$api.modal.show('', '入金は完了しています。', true, null);
      return;
    }
    if(this.checkedInvoices.filter(invoice=> (invoice.settlement & Common.SettlementTypes.ByCash) > 0).length > 0){
      this.$api.modal.show('', '入金は完了しています。', true, null);
      return;
    }
    if(this.checkedInvoices.filter(invoice=> invoice.billedBalanceAmountFC > 0).length ==0){
      this.$api.modal.show('', '請求残高がマイナスのため入金処理を実施できません。翌月への繰越処理を行ってください。', true, null);
      return;
    }

    this.showBilledReceiptDialogExec();

  }


  public showBilledReceiptDialogExec(){
    // プロパティの初期化
    this.brSegment = this.checkedInvoices[0].segment; //請求部門をセット(非表示)
    this.brPic = this.$api.auth.userId;    
    this.brWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_receivePayment');
    this.brCounterpart = this.checkedInvoices[0].counterpart;
    this.brCurrencyCode = this.checkedInvoices[0].currencyCode;
    this.brReceiptDate = this.checkedInvoices.map(invoice => invoice.dueDate).reduce((min, value) => min = (min == null || min > value) ? value : min);
    this.brBankAccount = this.checkedInvoices[0].bankAccount;
    this.brDescription = '';
    this.brCommissionAmountFC = 0;
    this.brCommissionTaxFlag = true; // 販売管理では課税固定
    this.brExchangeRate = 1;
    this.onChangeReceiptDate();
    this.onBilledReceiptChangeWorkflow();

    this.brDecimal = 0;
    const obj = this.$api.currencies.filter(obj => obj.value == this.brCurrencyCode);
    if (obj.length > 0) this.brDecimal = Number(obj[0].text);

    // ダイアログの表示
    (this.$refs.billedReceiptDialog as Components.ListDialog).items = this.checkedInvoices.filter(invoice=> invoice.currentAmountFC > 0);
    (this.$refs.billedReceiptDialog as Components.ListDialog).showDialog();
  }

  public async onChangeReceiptDate(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.brCurrencyCode;
    query.startDate = this.brReceiptDate;
    this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.brExchangeRate = exchangeRate ? exchangeRate.rate : 1;
    });
  }

  public onBilledReceiptChangeWorkflow(){
    this.buttonNames=new Array();
    this.buttonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.buttonNames.push("入金保存");
    if(this.brWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('receivePayment', this.brWorkflowId, Common.PaymentStatus.ReceiptPostWaiting);
      actions.forEach(action => {
        this.buttonNames.push(action.actionName);
        this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }
  // 入金処理の実行
  public async submitBilledReceipt(list: Array<Common.Invoice>, index:number) {
    // 実行前バリデーション
    if(this.brSettlementAmountFC != list.map(invoice => invoice.writeoffAmountFC).reduce((total, value) => total += value)){
      this.$api.modal.show('', '入金額合計が決済金額となるように入力してください。', true, null);
      return;
    }
    if(list.filter(invoice => invoice.currencyCode != this.tenantSettings.currencyCode && invoice.billedBalanceAmountFC < invoice.writeoffAmountFC).length > 0){
      this.$api.modal.show('', '売掛金残高を超える入金は、システム通貨のみ可能です。', true, null);
      return;
    }
    
    // クエリの設定
    var query = new Common.BilledReceiptQuery();
    query.isCarryOverInvoice = false;
    query.segment = this.brSegment;
    query.pic = this.brPic;
    query.workflowId = this.brWorkflowId;
    query.counterpart = this.brCounterpart;
    query.currencyCode = this.brCurrencyCode;
    query.receiptDate = this.brReceiptDate;
    query.bankAccount = this.brBankAccount;
    query.description = this.brDescription;
    query.exchangeRate = this.brExchangeRate;
    query.commissionAmountFC = this.brCommissionAmountFC;
    query.settlementAmountFC = this.brSettlementAmountFC;
    query.commissionTaxFlag = this.brCommissionTaxFlag;
    query.invoices = list;
    query.actionId = this.buttonIndexIdArray.filter(obj => obj.index==index)[0].actionId;

    // 入金処理の実行
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/cash/Deposit?paymentNo={0}', (res as Common.Payment).paymentNo));
    // });

    return this.$api.execute(query,true).then(res => {
      //リストリロード & 入金明細タブのリロード
      (this.$refs.mainList as Components.ListView).reload().then(()=>this.refreshPaymentList());
      var payment = res as Common.Payment;
      // this.$api.modal.show('処理結果','以下の入金伝票が作成されました。',true,null,[new Common.ModalLink(payment.paymentNo, String.format('/cash/Deposit?paymentNo={0}',payment.paymentNo))]);
      this.$api.modal.show('処理結果','以下の入金伝票が作成されました。',false,()=>this.$router.push(String.format('/cash/Deposit?paymentNo={0}',payment.paymentNo)),[new Common.ModalLink(payment.paymentNo, String.format('/cash/Deposit?paymentNo={0}',payment.paymentNo))],'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});        
  }

  // 入金情報タブ更新用プロパティ
  public isLoading:boolean = false;
  public totalPaymentAmountFC:number = 0;
  public totalPendingAmountFC:number = 0;
  public paymentJournals: Common.TransferJournal[]= new Array(0);

  // 一覧選択時に入金情報・前受金適用額一覧タブを更新
  public selectedInvoice: Common.Invoice;
  public onSelectedMain(index: number, selected: Common.Invoice) {
    this.selectedInvoice = selected;
    // 入金情報タブを更新
    this.totalPaymentAmountFC = 0;
    this.totalPendingAmountFC = 0;        
    this.paymentJournals = new Array(0);
    if(index >= 0) this.refreshPaymentList();
    
    // 前受金適用額一覧タブを更新
    this.advanceWriteoffamountFC = 0;
    this.advanceJournals = new Array(0);
    if(index >= 0) this.refreshAdvanceWriteoffList();
  }

  // 入金情報タブを更新
  public refreshPaymentList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;
    var totalWriteoffPendingAmountFC = 0;        
    // クエリの設定
    var query = new Common.PaymentJournalQuery();
    query.voucherNo = this.selectedInvoice.invoiceNo;
    query.isSend = false;

    // サーバーから入金情報を取得する
    this.$api.execute(query).then(res => {
      res = res as Common.LoadResult;
      this.paymentJournals = res.result;
      this.paymentJournals.forEach((obj, index) => {
          if (obj.isPosted) {
            totalWriteoffAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.ReceiptCompleted;
          } else {
            totalWriteoffPendingAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.ReceiptPostWaiting;            
          }
      });
    }).finally(()=>{
      this.isLoading = false;
      this.totalPaymentAmountFC = totalWriteoffAmountFC;
      this.totalPendingAmountFC = totalWriteoffPendingAmountFC;      
    });
  }

  // 入金一覧へ遷移する
  public onPaymentNoClick(paymentNo: string){
    this.$router.push(String.format('/cash/Deposit?paymentNo={0}',paymentNo));
  }
  //伝票へ遷移する
  public onOrderNoClick(orderNo: string){
    if (orderNo.startsWith("SO")) this.$router.push(String.format('/sales/SalesOrder?orderNo={0}',orderNo));
    else  this.$router.push(String.format('/cash/Deposit?paymentNo={0}',orderNo));
  }
  // 前受金適用額一覧タブ更新用プロパティ
  public advanceWriteoffamountFC:number = 0;
  public advanceJournals: Common.TransferJournal[]= new Array(0);

  // 前受金適用額一覧タブを更新
  public refreshAdvanceWriteoffList(){this.isLoading = true;
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;

    // クエリの設定
    var query = new Common.AdvanceJouralQuery();
    query.invoice = this.selectedInvoice;

    // サーバーから前受金適用額を取得する
    this.$api.execute(query).then(res => {
      res = res as Common.LoadResult;
      this.advanceJournals = res.result;
      this.advanceJournals.forEach((obj, index) => {
        totalWriteoffAmountFC += obj.amountFC;
      });
    }).finally(()=>{
      this.isLoading = false;
      this.advanceWriteoffamountFC = totalWriteoffAmountFC;
    });
  }

  // 受注伝票選択一覧ダイアログ用プロパティ
  public awaCounterpartName: string = '';
  public awaCounterpart: Common.Counterpart = null;
  // 受注伝票選択一覧ダイアログの表示
  public showAdvanceWriteoffAddDialog() {
    if (this.selectedInvoice != null)
    {
      this.isLoading = true;
      // this.awaCounterpartName = this.selectedInvoice.counterpart.name;
      this.awaCounterpart = this.selectedInvoice.counterpart;
      this.$api.execute(new Common.AdvanceBalanceQuery(this.selectedInvoice.counterpart.id,1)).then(res => {
        (this.$refs.advanceWriteoffAddDialog as Components.ListDialog).items = (res as Common.LoadResult).result ;
        (this.$refs.advanceWriteoffAddDialog as Components.ListDialog).showDialog();
      })
      .finally(()=>{
        this.isLoading = false;
      });
    }
  }

  // 前受金追加の実行
  public async submitAdvanceWriteoffAdd(list: Array<Common.Order>) {
    
    if (list.filter(obj =>obj.writeoffAmountFC != 0).length == 0){
        this.$api.closeWaitCursor();
        return this.$api.modal.showDialog('無効な操作','前受金消込額を指定してください。').then(()=>{return false;});      
    }

    this.isLoading = true;
    // クエリの設定
    var query = new Common.AdvanceWriteoffAddQuery();
    query.invoice = this.selectedInvoice;
    query.orders = list;

    // 前受金追加の実行
    await this.$api.execute(query).then(res => {
      // 前受金適用額一覧を更新
      this.refreshAdvanceWriteoffList();
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }

  // 前受金削除の実行
  public submitAdvanceWriteoffDelete() {
    // 前受金消込が0件の場合は、何もしない
    var journals:Array<any> = (this.$refs.advanceWriteoffListBox as Components.Grid).items;
    if(journals.length == 0) return;

    // 選択している前払金消込の取得
    var selectedId = (this.$refs.advanceWriteoffListBox as Components.Grid).selectedId;
    var journal = journals[selectedId];

    // クエリの設定
    var query = new Common.AdvanceWriteoffDeleteQuery();
    query.transferJournal = journal;

    // 前受金削除の実行
    this.isLoading = true;
    this.$api.execute(query).then(res =>{
      // 前受金適用額一覧を更新
      this.refreshAdvanceWriteoffList();
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }

   // 請求取消処理ダイアログの表示
  public showCancelBookSalesDialog() {
    let componentClass = Vue.extend(this.cancelBookSales);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedDeliveryItems: (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).selectedItems,
          parentMainList:this.$refs.mainList,
          gridVoucherItem: this.$refs.salesDeliveryItems,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  //消込明細のダイレクトエディットサポートをするためのエディタ
  public originalJournals: Array<Common.TransferJournal> = null;
  public getJournalEditor(){

    var listView = this.$refs.mainList as Components.ListView;
    var editor = new Editor();
    editor.isEdit = false;
    editor.owner = new CustomDirectEditProvider();
    editor.owner.onDirectEdit = () => {
      this.originalJournals = this.advanceJournals;
      this.advanceJournals = this.$api.createBinder('TransferJournal',true).loadInstance(this.originalJournals);
    };    
    editor.owner.onDirectCommit = () => {
        var items = this.advanceJournals.filter((obj,index) => obj.amountFC != this.originalJournals[index].amountFC);
        this.$api.execute(new Common.InvoiceJournalUpdateQuery(listView.selected, false, items))
        .then(res =>{this.$set(this.items, listView.currentId, res);})
        .catch(res => {this.advanceJournals = this.originalJournals;});        //エラーが出た場合は元戻し
    };
    editor.owner.onDirectClose = () =>{
      //ロールバック
      this.advanceJournals = this.originalJournals;
    }; 
    editor.owner.hasDirectPerm = () => {
      var editable = listView.selected.state == Common.InvoiceStatus.AloneClosingWaiting;
      return editable && this.$api.perms.hasWorkflowPermission(listView.selected.workflowHolder);
    };    

    return editor;
  }

  public showWriteoffDialog(item: Common.Invoice){

    this.$api.execute(new Common.InvoiceJournalTargetQuery(item)).then(res=>{
      var dialog = this.$refs.writeoffDialog as Components.ListDialog;
      dialog.items = res as Array<Common.TransferJournal>;
      dialog.showDialog();
    });
  }
  public async submitWriteoffDialog(list: Array<Common.TransferJournal>){
    // 実行前バリデーション
    var items = list.filter(obj =>obj.amountFC !=0);
    if(items.length ==0){
      this.$api.modal.show('', '前受金額を指定してください。', true, null);
      return;
    }    
    var listView = this.$refs.mainList as Components.ListView;
    this.$api.execute(new Common.InvoiceJournalUpdateQuery(listView.selected, false, items)).then(res =>{
      this.$set(this.items, listView.currentId, res);
    });
  }
  //入金削除
  public submitWriteoffDelete(){
      var listView = this.$refs.mainList as Components.ListView;
      var items = (this.$refs.advanceWriteoffListBox as Components.Grid).selectedItems;
      if (items.length == 0) {
        this.$api.modal.show('無効な操作','削除対象を選択してください。',true,null);
        return;
      }

      this.$api.modal.showDialog('確認メッセージ',String.format('{0}件の{1}を削除してよろしいですか？',items.length, '前受金'),false).then(()=>{
        this.$api.execute(new Common.InvoiceJournalUpdateQuery(listView.selected, true, items)).then(res =>{
          this.$set(this.items, listView.currentId, res);
        });        
      });
  }






  // 前受金追加・削除ボタン活性制御
  public disabledAdvanceWriteoff():boolean{
    return this.isLoading || this.selectedInvoice.state >= Common.InvoiceStatus.AloneReceiptWaiting;
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.AloneInvoice){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesInvoice, sourceNo : item.invoiceNo},this.$el);
  }

  // 請求明細一覧へ遷移する
  public showInvoiceItem(invoiceNo: string) {
    let routeData = this.$router.resolve(String.format('/sales/InvoiceItem?invoiceNo={0}', invoiceNo));
    window.open(routeData.href, '_blank');
  }

  public showRolloverDialog(cancel: boolean){
    var listView = this.$refs.mainList as Components.ListView;
    var items = listView.selectedItems as Array<Common.AloneInvoice>;

    //バリデーション(共通)
    if (items.length == 0){
      this.$api.modal.show('', '対象の請求伝票を選択して下さい。', true, null);      
      return;      
    }
    if (items.filter(obj =>obj.invoiceType == Common.InvoiceTypes.SeparateInvoice).length > 0) {
      this.$api.modal.show('', '請求方法が「締請求」の伝票を選択してください。', true, null);        
      return;
    }

    //バリデーション(個別)
    if(cancel){
      if (items.filter(obj =>(obj.rolloverFlag & Common.RolloverFlags.next) == 0).length > 0) {
        this.$api.modal.show('', '繰越処理が「今回実施済み」の伝票を選択してください。', true, null);        
        return;
      }
    } else {
      if (items.filter(obj =>(obj.rolloverFlag & Common.RolloverFlags.next) >0).length > 0) {
        this.$api.modal.show('', '繰越処理が「未実施」・「前回実施済み」の伝票を選択してください。', true, null);        
        return;
      }
      if (items.filter(obj =>obj.state == Common.InvoiceStatus.AloneClosingWaiting).length > 0) {
        this.$api.modal.show('', '請求締処理が実施された伝票を選択してください。', true, null);        
        return;
      }            
      if(items.filter(obj => obj.rolloverTarget(this.tenantSettings) == false).length > 0){
        this.$api.modal.show('', '繰越対象が「対象」の伝票を選択して下さい。', true, null);
        return;
      }
    }

    var title = cancel ? '繰越取消処理':'繰越処理';
    var message = cancel ? '繰越取消処理を実施すると次回請求書への残高繰越が解除されます。実施してよろしいですか？' :
      this.tenantSettings.dealApiType == Common.dealApiTypes.freee ? '繰越した次回の請求伝票はfreeeの取引伝票に連携できません。よろしいですか？' : '繰越処理を実施すると次回請求書に残高が繰り越されます。実施してよろしいですか？';

    this.$api.modal.showDialog(title,message,false)
    .then(()=>{ return this.$api.execute(new Common.InvoiceRolloverQuery(items,cancel))
    .then((result: Array<any>) =>{
      //一覧の置換処理
      result.forEach((updated: Common.Invoice) =>{
        var index = this.items.findIndex(item => item.invoiceNo == updated.invoiceNo);
        if(index > -1) this.$set(this.items, index, updated);
      });      
    });
    });
  }

  // 個別帳票出力
  public showCustomerReport(isMail: boolean = false){
    var listView = this.$refs.mainList as Components.ListView;
    var items = listView.selectedItems as Array<Common.AloneInvoice>;
    items.forEach(item =>{ item.designationReportTemplateId = item.counterpart.aloneInvoiceReportTemplateId;});
    if (isMail) (this.$refs.menuBar as Components.ListViewMenuBar).beforeDesignationReportSend(); // 得意先指定帳票メール送信前処理
    else (this.$refs.menuBar as Components.ListViewMenuBar).onDesignationReportGenerate();
    // if(items.length > 1){
    //   this.$api.modal.show('', '単一の伝票を選択してください。', true, null);
    //   return ;
    // }
    // var templates = (this.$refs.menuBar as Components.ListViewMenuBar).reports;
    // var template = templates.filter(obj => obj.id == items[0].counterpart.aloneInvoiceReportTemplateId)[0];
    // if(template==null){
    //   this.$api.modal.show('', '請求一覧指定帳票が指定されていません。取引先マスタで請求一覧指定帳票を設定してください。', true, null, [new Common.ModalLink('設定の方法はこちら','https://support.s-flow.net/ja/articles/8159389',true)]);
    //   return ;
    // }
    // var query = new Common.ReportQuery2(template.queryName, items);
    // query.templateId = template.id;
    // this.$api.download(query); 
  }

}
